import { render } from "./StatisticsCard.vue?vue&type=template&id=4fe21605&scoped=true"
import script from "./StatisticsCard.vue?vue&type=script&lang=js"
export * from "./StatisticsCard.vue?vue&type=script&lang=js"

import "./StatisticsCard.vue?vue&type=style&index=0&id=4fe21605&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fe21605"]])

export default __exports__